import { FC } from 'react'

import type { Standing } from '@/types/dde/golfLeaderboard.types'

import { GolfScoreboardCellKey, ScoreboardCells } from './constants'
import { GolfScoreboardCell, ScoreboardCellValue } from './GolfScoreboardCell'
import type { TeamRoundHeaderProps } from './GolfScorecardHeader'
import { formatValue } from './utils'

interface GolfScoreboardCellsProps {
  teamRound: TeamRoundHeaderProps
  teamStanding?: Standing
}

export const GolfScoreboardCells: FC<GolfScoreboardCellsProps> = ({ teamRound, teamStanding }) => {
  const {
    roundNo = -1,
    strokeNo = -1,
    holeNo = -1,
    ballLie: { distanceToPin, surfaceType }
  } = teamRound

  const positionValue = teamStanding?.position?.displayValue
  const scoreValue = teamStanding?.toPar?.displayValue

  const CellsValues: Record<GolfScoreboardCellKey, ScoreboardCellValue> = {
    [GolfScoreboardCellKey.CurrentRound]: formatValue(roundNo),
    [GolfScoreboardCellKey.Hole]: formatValue(holeNo),
    [GolfScoreboardCellKey.Stroke]: formatValue(strokeNo),
    [GolfScoreboardCellKey.ToPin]:
      (distanceToPin !== -1 && distanceToPin !== null && `${distanceToPin.toFixed(2)}m`) || null,
    [GolfScoreboardCellKey.BallLie]: surfaceType,
    [GolfScoreboardCellKey.Position]: positionValue || null,
    [GolfScoreboardCellKey.Score]: scoreValue || null
  }

  return (
    <>
      {Object.entries(ScoreboardCells).map(([key, cellProps]) => {
        const cellKey = key as GolfScoreboardCellKey

        return <GolfScoreboardCell key={cellKey} {...cellProps} value={CellsValues[cellKey]} />
      })}
    </>
  )
}
